import {
  ReadOTPReceived,
  RemoveSmsListenerIfRegistered
} from "./autoOtpRead";
export {
  ReadOTPReceived,
  RemoveSmsListenerIfRegistered
};